import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';

export const SideMenu = (): JSX.Element => {
  const location = useLocation();

  return (
    <Menu
      mode="inline"
      theme="light"
      selectedKeys={[location.pathname]}
      onSelect={() => window.scrollTo(0, 0)}
      style={{ height: '100%', borderRight: 0 }}
    >
      <Menu.Item key="/">
        <Link to="/">Home</Link>
      </Menu.Item>
      <Menu.Item key="/changelogs">
        <Link to="/changelogs">Changelogs</Link>
      </Menu.Item>
      <Menu.Item key="/api">
        <Link to="/api">API</Link>
      </Menu.Item>
    </Menu>
  );
};
